
import type { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import ProductsPage from '../pages/products/page';
import IndustriesPage from '../pages/industries/page';
import ContactPage from '../pages/contact/page';
import QuotePage from '../pages/quote/page';
import PrivacyPage from '../pages/privacy/page';
import TermsPage from '../pages/terms/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/industries',
    element: <IndustriesPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/quote',
    element: <QuotePage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
